import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bem } from '@argos/utils'
import Button from '@boltui/button'

import { Creators as FormsCreators } from '../../../actions'
import SliderBar from './SliderBar'

const cn = bem({ prefix: 'lc-', block: 'feedback-slider' })

export class Slider extends React.Component {
  static propTypes = {
    buttonText: PropTypes.string,
    dragging: PropTypes.bool,
    id: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    question: PropTypes.string,
    scale: PropTypes.array,
    showToolTip: PropTypes.bool,
    startDrag: PropTypes.func,
    stopDrag: PropTypes.func,
    toolTipOff: PropTypes.func,
    toolTipOn: PropTypes.func,
    trackingCode: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  constructor(props) {
    super(props)
    this.state = { xPosition: 50 } /* default to 50% */
    this.bar = React.createRef()
  }

  get trackingCode() {
    return this.props.trackingCode.replace('{rating}', this.props.value)
  }

  componentDidMount() {
    this.props.onChange(this.state.xPosition / 10)
  }

  handleDrag = (evt, scale) => {
    evt.preventDefault()
    if (this.props.dragging) {
      this.calculatePercentage(evt, scale)
    }
  }

  handleStopDrag = () => {
    if (this.props.dragging) this.props.stopDrag()
  }

  xCoordinateWithinBar = (evt) => {
    const rect = this.bar.current.getBoundingClientRect()
    return (evt.touches ? evt.touches[0].clientX : evt.clientX) - rect.left
  }

  calculateXPosition = (evt) => Math.ceil((this.xCoordinateWithinBar(evt) / this.bar.current.offsetWidth) * 100)

  clamp = (num, min, max) => {
    if (num <= min) {
      return min
    }

    if (num >= max) {
      return max
    }

    return num
  }

  calculatePercentage = (evt, scale, setXPos) => {
    const startingValue = scale[0]
    const size = scale[1] - scale[0]
    const xPos = typeof evt !== 'undefined' ? this.calculateXPosition(evt) : setXPos

    this.setNewXPosition(xPos)
    const value = Math.round(size * (this.clamp(xPos, 0, 100) / 100) + startingValue)

    if (this.props.value !== value) {
      this.props.onChange(value)
    }
  }

  handleKeyPresses(evt, scale) {
    switch (evt.keyCode) {
      case 38:
        this.calculatePercentage(undefined, scale, this.state.xPosition + 10)
        break
      case 40:
        this.calculatePercentage(undefined, scale, this.state.xPosition - 10)
        break
      default:
        break
    }
  }

  setNewXPosition = (xPosition) => {
    this.setState({
      xPosition: this.clamp(xPosition, 0, 100),
    })
  }

  render() {
    const {
      question,
      buttonText,
      dragging,
      onSubmit,
      id,
      startDrag,
      value,
      showToolTip,
      toolTipOn,
      toolTipOff,
    } = this.props

    const { xPosition } = this.state

    const scale = [parseInt(this.props.scale[0], 0), parseInt(this.props.scale[this.props.scale.length - 1], 0)]

    return (
      <form
        role='presentation'
        className={`${cn()} lc-controls__form lc-controls__form--with-seperator`}
        onTouchStart={() => startDrag()}
        onTouchEnd={this.handleStopDrag}
        onMouseUp={this.handleStopDrag}
        onMouseLeave={this.handleStopDrag}
        onTouchMove={(evt) => this.handleDrag(evt, scale)}
        onMouseMove={(evt) => this.handleDrag(evt, scale)}>
        <h4 className={cn('question-text')}>{question}</h4>
        <br />
        <div
          role='slider'
          aria-valuemax={scale[1]}
          aria-valuemin={scale[0]}
          aria-valuenow={value}
          tabIndex='0'
          onFocus={() => toolTipOn()}
          onBlur={() => toolTipOff()}
          onKeyDown={(evt) => {
            toolTipOn()
            this.handleKeyPresses(evt, scale)
          }}
          onMouseDown={(evt) => {
            startDrag()
            this.calculatePercentage(evt, scale)
          }}>
          <div className='container'>
            <div aria-label={question} className={cn('container', 'bar')} ref={this.bar}>
              <span className={cn('scale-start-text')}>0</span>
              <SliderBar
                xPosition={xPosition}
                value={value}
                dragging={dragging}
                startDrag={startDrag}
                showToolTip={showToolTip}
              />
              <span className={cn('scale-end-text')}>10</span>
            </div>
            <br />
          </div>
        </div>
        <Button
          full
          data-test={cn('btn-next')}
          className={`${cn('btn-next')} button`}
          onClick={() => {
            onSubmit({
              id,
              value,
              trackingCode: this.trackingCode,
            })
          }}>
          {buttonText}
        </Button>
      </form>
    )
  }
}

const mapStateToProps = (state) => ({
  dragging: state.Forms.dragging,
  value: state.Forms.inputValue,
  showToolTip: state.Forms.showToolTip,
})

const mapDispatchToProps = (dispatch) => ({
  startDrag: () => dispatch(FormsCreators.startDrag()),
  stopDrag: () => dispatch(FormsCreators.stopDrag()),
  toolTipOn: () => dispatch(FormsCreators.toolTipOn()),
  toolTipOff: () => dispatch(FormsCreators.toolTipOff()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Slider)
